import React from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaClock } from 'react-icons/fa';

const LocationMap = () => {
  // Coordenadas do endereço em Curitiba - Rua Londrina, 217
  const latitude = -25.4831;
  const longitude = -49.2904;
  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=Rua+Londrina+217+Sitio+Cercado+Curitiba+PR+81900-390`;
  const mapEmbedUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=Rua+Londrina+217+Sitio+Cercado+Curitiba+PR+81900-390&zoom=15&maptype=roadmap`;

  // Animação para o mapa
  const mapAnimation = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { 
        type: "spring", 
        damping: 20, 
        stiffness: 100,
        duration: 0.8 
      }
    },
    hover: {
      boxShadow: "0 0 30px rgba(234, 179, 8, 0.7)",
      scale: 1.02,
      transition: { duration: 0.3 }
    }
  };

  return (
    <div className="location-container">
      {/* Botão "COMO CHEGAR" */}
      <div className="flex justify-center mb-4">
        <motion.a
          href={googleMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="relative bg-black border-2 border-gold rounded-md py-3 px-8 flex items-center justify-center w-64 max-w-xs text-gold font-bold tracking-wider uppercase"
          whileHover={{ 
            boxShadow: "0 0 15px rgba(234, 179, 8, 0.7)"
          }}
          whileTap={{ scale: 0.98 }}
          style={{ zIndex: 40 }}
        >
          <FaMapMarkerAlt className="mr-3 text-gold" />
          COMO CHEGAR
        </motion.a>
      </div>

      {/* Horário de funcionamento */}
      <div className="flex justify-center mb-8">
        <motion.div 
          className="flex items-center text-gold text-sm"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
        >
          <FaClock className="mr-2 text-gold" />
          <span>Horário de funcionamento: Ter-Sáb 09:00 às 20:00 | Dom 09:00 às 13:30</span>
        </motion.div>
      </div>
      
      {/* Mapa */}
      <motion.div 
        className="container mx-auto px-4 mb-6"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        <motion.div 
          className="overflow-hidden rounded-lg shadow-lg border-2 border-gold"
          variants={mapAnimation}
          initial="hidden"
          animate="visible"
          whileHover="hover"
        >
          <div className="relative w-full h-0 pb-[50%] md:pb-[40%]">
            <iframe
              className="absolute top-0 left-0 w-full h-full border-none"
              src={mapEmbedUrl}
              allowFullScreen
              loading="lazy"
              title="Localização da PorterHouse Carnes"
            ></iframe>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default LocationMap; 